///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useIntl } from "react-intl";

import Modal from "../../Modal";
import messages from "../../../helpers/messages";
import ChevronRight from "../../icons/ChevronRight";
import WarningIcon from "../../icons/WarningIcon";

export const MatchOverwriteModal = ({
  open,
  laneIds,
  handleClose,
  handleOverwriteAndContinue
}) => {
  const intl = useIntl();

  return (
    <Modal
      title={messages.matchOverwrite.defaultMessage}
      open={open}
      large={true}
      handleClose={handleClose}
      titleClass="modal__title_light uppercase"
      bodyClass="border-top-grey px-24 pt-24"
      closeButtonClass="modal__close-button mr-16 mt-16"
      modalStyle={{ width: 470 }}
    >
      <p className="text-center m-0">
        <WarningIcon height={40} width={40} />
      </p>
      <p
        data-testid="warning-message"
        className="delta-heading text-center text-black pb-4"
      >
        {messages.areYouSureYouWantToOverwriteMatches.defaultMessage}
      </p>
      <p
        data-testid="confirmation-message"
        className="font-size-14 text-center text-grayish-blue m-0 pb-8"
      >
        {intl.formatMessage(messages.overwriteMatchesConfirmationMessage, {
          laneIds: <b>{laneIds}</b>
        })}
        <span className="font-bold">
          {" "}
          {messages.thisCannotBeUndone.defaultMessage}
        </span>
      </p>

      <div className="grid fr my-24">
        <div className="grid__cell pl-8">
          <button
            data-testid="overwrite-and-continue"
            className="text-button one-whole cursor-pointer text-transform-none short-button"
            onClick={handleOverwriteAndContinue}
            style={{ minWidth: 170 }}
          >
            {messages.overwriteAndContinue.defaultMessage}
            <ChevronRight className="align-text-bottom ml-8" fill="#0066FA" />
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default MatchOverwriteModal;
